import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProposteGestione } from 'src/app/models/proposte-gestione';
@Injectable({
  providedIn: 'root',
})
export class ProposteGestioneService {
  private http = inject(HttpClient);
  pcrUrl = environment.ildatoArticoliDpi + 'api/propostegestione';

  list(): Observable<ProposteGestione[]> {
    return this.http.get<ProposteGestione[]>(this.pcrUrl);
  }

  get(id: number): Observable<ProposteGestione> {
    return this.http.get<ProposteGestione>(this.pcrUrl + '/' + id);
  }

  search(searchObj: any): Observable<ProposteGestione[]> {
    let filter = '';
    if (searchObj.idDipendente) {
      filter += 'IdDipendente=' + searchObj.idDipendente + '&';
    }
    if (searchObj.idArticolo) {
      filter += 'IdArticolo=' + searchObj.idArticolo + '&';
    }
    if (searchObj.idTipoArticolo) {
      filter += 'IdTipoArticolo=' + searchObj.idTipoArticolo + '&';
    }
    if (searchObj.tipoProposta) {
      filter += 'TipoProposta=' + searchObj.tipoProposta + '&';
    }
    if (searchObj.daData) {
      filter += 'DaData=' + searchObj.daData + '&';
    }
    if (searchObj.aData) {
      filter += 'AData=' + searchObj.aData + '&';
    }
    if (filter.length > 0) {
      filter = '?' + filter.slice(0, -1).trim();
    }
    return this.http.get<ProposteGestione[]>(this.pcrUrl + '/search' + filter);
  }

  listNonViste(): Observable<ProposteGestione[]> {
    return this.http.get<ProposteGestione[]>(this.pcrUrl + '/nonviste');
  }

  insert(values: ProposteGestione): Observable<ProposteGestione> {
    return this.http.post<ProposteGestione>(this.pcrUrl, values);
  }

  remove(idReparto: number): Observable<ProposteGestione> {
    return this.http.delete<ProposteGestione>(this.pcrUrl + '/' + idReparto);
  }

  update(key: number, values: ProposteGestione): Observable<ProposteGestione> {
    return this.http.put<ProposteGestione>(this.pcrUrl + '/' + key, values);
  }

  setViste(keys: any): Observable<boolean> {
    return this.http.post<boolean>(this.pcrUrl + '/setviste', keys);
  }
}
